import { render, staticRenderFns } from "./Tab_Route.vue?vue&type=template&id=1e39845a&scoped=true"
import script from "./Tab_Route.vue?vue&type=script&lang=js"
export * from "./Tab_Route.vue?vue&type=script&lang=js"
import style0 from "./Tab_Route.vue?vue&type=style&index=0&id=1e39845a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e39845a",
  null
  
)

export default component.exports